import Style from '../style/Style.tsx';

export type LoadIndicatorContainerProps = {
	children: React.ReactNode;
};

const LoadIndicatorContainer: React.FC<LoadIndicatorContainerProps> = ({
	children,
}) => <Style className="blk-ac-load-indicator">{children}</Style>;

export default LoadIndicatorContainer;
